// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"6a2d7cd8","144":"728c5171","212":"a5c3bf8c","297":"9c672269","474":"d1102ca7","532":"fc1874ed","717":"5adaa59d","793":"c93fbb16","812":"52f0a812"}[chunkId] + ".chunk.js";
};